import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ApiError } from './api/client';
import { App } from './App';
import { AuthProvider } from './auth/AuthProvider';
import './i18n';
import './styles.css';
import { themeStyleSheet } from './theme';
import { ThemeModeProvider } from './themeMode';

// the custom properties of both themes, before anything renders
const themeStyle = document.createElement('style');
themeStyle.id = 'wm-theme';
themeStyle.textContent = themeStyleSheet;
document.head.prepend(themeStyle);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // a 401 was already retried after renewing the session (authorizedFetch)
      retry: (failures, error) =>
        failures < 1 && !(error instanceof ApiError && error.problem.status === 401),
      refetchOnWindowFocus: false,
    },
  },
});

// the router wraps the authentication, which opens the page the user signed in from
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ThemeModeProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ThemeModeProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
